export default {
    DELAY_CAUSED_BY_SERVICE_CENTER: {
        CONTAINER_NOT_READY: 'CONTAINER_NOT_READY',
        BLOCKED_LOADING_RAMPS: 'BLOCKED_LOADING_RAMPS',
        OTHER: 'OTHER',
    },
    DELAY_CAUSED_BY_TRUCKING_COMPANY: {
        TRUCK_DELAY: 'TRUCK_DELAY',
        TRUCK_CANCELLATION: 'TRUCK_CANCELLATION',
        INCORRECT_TEMP_SET_POINT: 'INCORRECT_TEMP_SET_POINT',
        INCORRECT_TRUCK_SIZE: 'INCORRECT_TRUCK_SIZE',
        INCORRECT_NUMBER_OF_TRUCKS: 'INCORRECT_NUMBER_OF_TRUCKS',
        WRONG_TRUCK_DETAILS: 'WRONG_TRUCK_DETAILS',
        NO_PICK_UP_DELIVERY_SLOT_BOOKED: 'NO_PICK_UP_DELIVERY_SLOT_BOOKED',
        DRIVE_ISSUE: 'DRIVE_ISSUE',
        DRIVING_TO_WRONG_LOCATION: 'DRIVING_TO_WRONG_LOCATION',
        OTHER: 'OTHER',
    },
    DELAY_CAUSED_BY_SKYCELL: {
        INCORRECT_ORDER_MANAGEMENT: 'INCORRECT_ORDER_MANAGEMENT',
        DELAYED_CONTAINER_SELECTION: 'DELAYED_CONTAINER_SELECTION',
        CONTAINER_AVAILABILITY: 'CONTAINER_AVAILABILITY',
        OTHER: 'OTHER',
    },
    OTHER: {
        TRUCK_BREAKDOWN: 'TRUCK_BREAKDOWN',
        UNEXPECTED_TRAFFIC_JAM: 'UNEXPECTED_TRAFFIC_JAM',
        FORCE_MAJEURE: 'FORCE_MAJEURE',
        OTHER: 'OTHER',
    },
}
